export default __webpack_public_path__ + "static/media/IMG-20241210-WA0021.72366dc1.jpg";